export const generateSchemaId = (label: string) => {
  return label
    .toLowerCase()
    .normalize('NFD') // Decompose accented characters
    .replace(/[\u0300-\u036f]/g, '') // Remove diacritical marks
    .replace(/[-–—]+/g, ' ') // Convert various dashes to spaces
    .replace(/[^a-z0-9\s_]/g, '') // Remove other invalid characters
    .replace(/\s+/g, '_') // Replace whitespace with underscores
    .replace(/_+/g, '_') // Collapse multiple underscores
    .replace(/^_+|_+$/g, ''); // Trim underscores from start/end
};
